import * as Icons from 'react-icons/fa';

interface FontAwesomeIconProps {
  name: string;
  className: string;
}

const FontAwesomeIcon = ({ name = '', className = '' }: FontAwesomeIconProps) => {
  if (!name) return null;
  const pascal = name
    .split('-')
    .map((s) => s.charAt(0).toUpperCase() + s.slice(1))
    .join('');
  const IconCmp = Icons[('Fa' + pascal) as keyof typeof Icons];

  if (!IconCmp) return null;
  return <IconCmp className={className} />;
};

export default FontAwesomeIcon;
